import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';
import {
  Option
} from './component/common';
import Home from './container/home';
import Search from './container/search';
import Privacy from './container/privacy';
import HouseDetail from './container/housedetail';
import WebSearch from './container/websearch'
import WebHome from './container/webhome '
import Empty from './component/common/Empty';
import { isShowOption } from './utils/func'

function App() {
  return (
    <div className={isShowOption() ? 'max-w-[450px] mx-auto relative' : ''}>
      {
        isShowOption() ? <Option /> : ''
      }
      <Router>
        <Switch>
            <Route path="/websearch" component={Home} />
            <Route path="/webhome" component={WebHome} />
            <Route path="/detail" component={HouseDetail} />
            <Route path="/privacy" component={Privacy} />
            <Route path="/search" component={Search} />
            <Route path="/empty" component={Empty} />
            <Route path="/" component={WebSearch} />
            <Redirect to="/" />
          </Switch>
      </Router>
    </div>
  );
}

export default App;
